import * as React from 'react';
import { Form as RawForm, createFormActions, FormPath } from '@formily/react';
import { useRequest } from 'huse';
import Error from '@baidu/icloud-ui-error';
import { Spin } from '@osui/ui';
import { FieldContext } from '../Other';
import { scrollIntoView } from '../utils';
import { useExtendsEffects } from './extendsEffects';
import { jsx as _jsx } from "react/jsx-runtime";
export const InnerForm = props => {
  const {
    effects: effectsIn,
    actions: actionsIn,
    recordFormChange,
    ...rest
  } = props;
  const actions = React.useMemo(() => {
    if (actionsIn != null) {
      return actionsIn;
    }

    return createFormActions();
  }, [actionsIn]);
  React.useEffect(() => {
    actions.disableUnmountClearStates();
  }, [actions]);
  const onValidateFailed = React.useCallback(result => {
    if (rest.onValidateFailed) {
      rest.onValidateFailed(result);
    }

    scrollIntoView();
  }, [rest]);
  const effects = useExtendsEffects(props);
  return /*#__PURE__*/_jsx(RawForm, {
    actions: actions,
    ...rest,
    onValidateFailed: onValidateFailed,
    effects: effects
  });
};

function AsyncInitialForm({
  asyncInitialValues,
  ...rest
}) {
  const request = React.useMemo(() => asyncInitialValues || (() => Promise.resolve(undefined)), [asyncInitialValues]);
  const {
    data,
    error,
    pending
  } = useRequest(request, {});

  if (error) {
    return /*#__PURE__*/_jsx(Error, {
      error: error.message
    });
  }

  if (asyncInitialValues) {
    return /*#__PURE__*/_jsx(Spin, {
      spinning: pending,
      children: /*#__PURE__*/_jsx(InnerForm, {
        initialValues: data,
        ...rest
      }, String(data))
    });
  }

  return /*#__PURE__*/_jsx(InnerForm, { ...rest
  });
}

AsyncInitialForm.displayName = "AsyncInitialForm";
export const Form = props => {
  const fieldProviderVal = React.useMemo(() => {
    return {
      preName: FormPath.parse('')
    };
  }, []); // 这里多封装了一层。因为在嵌套的时候，里面form的field会受到外面的影响。这样就不会了。

  return /*#__PURE__*/_jsx(FieldContext.Provider, {
    value: fieldProviderVal,
    children: /*#__PURE__*/_jsx(AsyncInitialForm, { ...props
    })
  });
};
//# sourceMappingURL=es/Form/Form.js.map